import * as i18n from "i18next";
import en from "./i18n/en";
import fr from "./i18n/fr";

export default (language) =>
    i18n.init({
        lng: language,
        resources: {
            en: { translation: en },
            fr: { translation: fr }
        }
    });


// WEBPACK FOOTER //
// ./src/i18n.js